import React from 'react';

interface Props {
  title: string;
  value: string | number;
  icon: React.ReactNode;
  highlight?: boolean;
  subtitle?: string;
}

// Compact KPI card used across the Booking Dashboard.
export default function BookingStatsCard({ title, value, icon, highlight, subtitle }: Props) {
  return (
    <div className="bg-strivre-softgrey border border-strivre-lightnavy rounded-lg p-5 flex items-start justify-between">
      <div>
        <p className="text-xs font-semibold uppercase tracking-wide text-strivre-mutedtext">{title}</p>
        <p className={`mt-2 text-2xl font-bold ${highlight ? 'text-strivre-burgundy' : 'text-strivre-navy'}`}>{value}</p>
        {subtitle && <p className="mt-1 text-xs text-strivre-mutedtext">{subtitle}</p>}
      </div>
      <div className={`p-2.5 rounded-lg ${highlight ? 'bg-strivre-lightburgundy text-strivre-burgundy' : 'bg-strivre-lightnavy text-strivre-navy'}`}>
        {icon}
      </div>
    </div>
  );
}
